// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-edit[data-v-023d3e8b]{margin:20px 10px}.user-edit .dialog-footer[data-v-023d3e8b]{padding-left:80px}.avatar-uploader-icon[data-v-023d3e8b]{font-size:28px;color:#1846a3;width:80px;height:80px;line-height:80px;text-align:center;background-color:#fff}", ""]);
// Exports
module.exports = exports;
